/*--------------------------
	Get Browser Version
--------------------------*/
(function($, window, document, undefined) {

	var getBrowser = function() {

		var ua = navigator.userAgent.toLowerCase();
		var ver = navigator.appVersion.toLowerCase();
		var browser = 'unknown';

		if (ua.indexOf("msie") != -1){
			if (ver.indexOf("msie 6.") != -1){
				name = 'ie6';
			} else if (ver.indexOf("msie 7.") != -1) {
				name = 'ie7';
			} else if (ver.indexOf("msie 8.") != -1) {
				name = 'ie8';
			} else if (ver.indexOf("msie 9.") != -1) {
				name = 'ie9';
			} else if (ver.indexOf("msie 10.") != -1) {
				name = 'ie10';
			} else {
				name = 'ie';
			}
		} else if (ua.indexOf('trident/7') != -1) {
			name = 'ie11';
		} else if (ua.indexOf('chrome') != -1) {
			name = 'chrome';
		} else if (ua.indexOf('safari') != -1) {
			name = 'safari';
		} else if (ua.indexOf('opera') != -1) {
			name = 'opera';
		} else if (ua.indexOf('firefox') != -1) {
			name = 'firefox';
		}

		return name;

	}

	window.getBrowser = getBrowser;

})(jQuery, window, document);

var $rwd = $('#navBtn');

$(function(){
	//item slider
	var slideFlag = false;
	var $slider = $('#slider');
	var $recommend = $('#recommend');
	var option = {
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 800,
		cssEase: 'ease',
		fade: true,
		infinite: true,
		arrows: false,
		dots: true,
		customPaging: function(slick, index){
			var num = slick.$slides.eq(index).find('img').attr('src');
			return '<span style="background-image: url(' + num + ');"></span>';
		},
		draggable: false,
		pauseOnFocus: false,
		pauseOnHover: false,
		responsive: [
			{
				breakpoint: 812,
				settings: {
					customPaging: function(slick, index){
						var num = index + 1;
						return '<button>'+num+'</button>';
					},
				}
			}
		]
	}
	var subOption = {
		autoplay: false,
		speed: 500,
		cssEase: 'ease',
		infinite: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		draggable: false,
		pauseOnFocus: false,
		pauseOnHover: false,
	}

	if ($slider.length) {
		$slider.slick(option);
		var recLenght = $recommend.children('.col').length;
		var set = 2;
		if (recLenght <= set) {
			$recommend.addClass('def');
		} else {
			settingSlide();
		}
		$(window).on('resize', settingSlide);
	}

	function settingSlide() {
		if ($rwd.is(':hidden')) {
			if (slideFlag) {
				slideFlag = false;
				$recommend.slick('unslick');
			}
		} else {
			if (!slideFlag) {
				slideFlag = true;
				if (!$recommend.hasClass('def')) {
					$recommend.slick(subOption);
				}
			}
		}
	}

	var $featureSlider = $('.featureSlider');
	var $featureDetail = $('.detailSlider');
	for(var i = 0 ; i < $featureSlider.length ; i++){
		var tg = $featureSlider.eq(i);
		var detail = tg.parent('.sliderWrap').next('.detailSlider');
		tg.on('init', function(event, slick) {
			var c = slick.currentSlide + 1;
			var t = slick.slideCount;
			if (t >= 2) {
				tg.parent('.sliderWrap')
				.append('<p class="number fontEn"><span class="c"></span>/<span class="t"></span></p>');
				var current = tg.next('.number').find('.c');
				var total = tg.next('.number').find('.t');
				current.text(c);
				total.text(t);
			}
		}).slick({
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 800,
			cssEase: 'ease',
			infinite: true,
			draggable: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			asNavFor: detail
		}).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			var c = nextSlide + 1;
			var num = slick.$slider.next('.number').find('.c');
			num.text(c);
		});
	}

	for(var i = 0 ; i < $featureDetail.length ; i++){
		var tg = $featureDetail.eq(i);
		var images = tg.prev('.sliderWrap').children('.featureSlider');
		tg.slick({
			autoplay: false,
			speed: 800,
			cssEase: 'ease',
			fade: true,
			arrows: false,
			infinite: true,
			draggable: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			asNavFor: images
		});
	}

	var state = false;
	var scrollpos;

	//scDown
	$('#scDown').on('click', function(e){
		e.preventDefault();
		var speed = 800;
		var position = $('#main').offset().top;
		$('body,html').animate({scrollTop:position},speed,'easeInOutQuart');
		return false;
	});

	$('.anc').on('click', function(e){
		e.preventDefault();
		var speed = 800;
		var target = $(this).attr('href');
		var position = $(target).offset().top;
		position = position - 50;
		if ($('#navBody').is(':visible')) {
			scrollFixed();
			$('#navBtn button').removeClass('open');
			$('#navBody').fadeOut(800, function(){
				position = $(target).offset().top;
				position = position - 50;
				$('body,html').animate({scrollTop:position},speed,'easeInOutQuart');
				$('#nav').removeClass('trans move').removeAttr('style');
			});
		} else {
			$('body,html').animate({scrollTop:position},speed,'easeInOutQuart');
		}
		return false;
	});

	//nav
	$('#navBtn').on('click', function(e){
		var $nav = $('#navBody');
		scrollFixed();
		if ($nav.is(':hidden')) {
			$(this).addClass('open');
			$nav.fadeIn(600);
		} else {
			$(this).removeClass('open');
			$nav.fadeOut(600);
		}
	});

	//news category
	$('#newsCat').on('click', function(e){
		var tg = $(this).next('.catBody');
		if (tg.is(':hidden')) {
			tg.slideDown();
		} else {
			tg.slideUp();
		}
	});

	//item cart
	if ($('#cart').length) {
		$('#cart input[type="submit"]').val('ADD TO CART');
	}

	//item sort
	$('#sortBtn').on('click', function(e){
		var $menu = $('#sortBody');
		scrollFixed();
		if ($menu.is(':hidden')) {
			$menu.fadeIn(600);
		}
	});

	$('#sortClose').on('click', function(e){
		var $menu = $('#sortBody');
		scrollFixed();
		if ($menu.is(':visible')) {
			$menu.fadeOut(600);
		}
	});

	$('.sortAc').on('click', function(e){
		e.preventDefault();
		var target = $(this).attr('href');
		if ($(target).is(':hidden')) {
			$(this).addClass('open');
			$(target).slideDown();
		} else {
			$(this).removeClass('open');
			$(target).slideUp();
		}
	});

	var $sortChk = $('input[name="sortChk"]');
	var $sortBtn = $('#sort');
	var params = location.search;
	if (params) {
		var hrefurl = $sortBtn.attr('data-href');
		$sortBtn.attr('href', hrefurl + params).removeClass('disable');
	}

	$sortChk.click(function(){
		var chkCount = $('input[name="sortChk"]:checked').length;
		if (chkCount == 0 && !$sortBtn.hasClass('disable')){
			$sortBtn.addClass('disable');
		} else {
			if ($sortBtn.hasClass('disable')) {
				$sortBtn.removeClass('disable');
			}
		}
	});
	$sortChk.change(function(){
		var aryCmp = [];
		var href = $sortBtn.attr('data-href');
		$('input[name="sortChk"]:checked').each(function(i, e){
			aryCmp.push($(e).val());
		});
		var param = aryCmp.join('&itemtag[]=');
		$sortBtn.attr('href', href + '?itemtag[]=' + param);
	});
	$('#sortSide .sortReset').click(function(){
		var href = $sortBtn.attr('data-href');
		$sortChk.prop('checked', false);
		$sortBtn.attr('href', href).addClass('disable');
	});

	function scrollFixed(){
		if(state == false) {
			scrollpos = $(window).scrollTop();
			$('body').css({'overflow-y': 'scroll'});
			$('#wrap').addClass('fixed').css({'top': -scrollpos});
			state = true;
		} else {
			$('body').removeAttr('style');
			$('#wrap').removeClass('fixed').removeAttr('style');
			window.scrollTo(0 , scrollpos);
			state = false;
		}
	}
});

//scroll Effect
(function() {
	var $elems = $('.scrEff');
	var show = 0.7;

	function init(){
		setup();
		scroll();
	}

	function setup(){
		if ($elems.length) {
			for(var i = 0 ; i < $elems.length ; i++){
				var tg = $elems.eq(i);
				tg.addClass('is-hidden');
			}
		}
	}

	function scroll(){
		var sT = $(window).scrollTop();
		var winH = window.innerHeight;
		if ($elems.length) {
			for(var i = 0 ; i < $elems.length ; i++){
				var tg = $elems.eq(i);
				var getTop = tg.offset().top;
				if (sT + winH * show > getTop) {
					tg.removeClass('is-hidden');
				}
			}
		}
	}

	$(window).on('load', init);
	$(window).on('scroll resize', scroll);
	document.addEventListener('touchmove', scroll);
})();

//feature
(function() {
	var $elems = $('.pllxImage');

	function pllx(){
		var sT = $(window).scrollTop();
		var winH = window.innerHeight;
		if ($elems.length) {
			for(var i = 0 ; i < $elems.length ; i++){
				var tg = $elems.eq(i);
				var getTop = tg.offset().top;
				var getHeight = tg.height();
				var bottom = getTop + getHeight;
				if (sT > getTop - winH && sT < bottom) {
					var num = sT + winH - getTop;
					num = (-num*0.15);
					tg.find('span').css({'transform': 'translate3d(0,'+num+'px,0'});
				}
			}
		}
	}

	$(window).on('load', pllx);
	$(window).on('scroll resize', pllx);
	document.addEventListener('touchmove', pllx);
})();